export default __webpack_public_path__ + "static/media/ranking-help.c1c2119f.png";